import React from "react";

// Mikassa Agency mark — stylized M logo
export const MikassaMark = ({ size = 48, tone = "orange", className = "" }) => {
  // Use CSS filter to colorize the logo based on tone
  // Original logo is blue, we shift it to orange or white
  const filterStyle = tone === "white"
    ? { filter: "brightness(0) invert(1)" }  // White
    : tone === "navy"
    ? { filter: "brightness(0) saturate(100%) invert(10%) sepia(30%) saturate(2000%) hue-rotate(180deg)" } // Navy
    : { filter: "brightness(0) saturate(100%) invert(45%) sepia(90%) saturate(1500%) hue-rotate(350deg) brightness(95%)" }; // Orange

  return (
    <img
      src="/logo.png"
      alt="Mikassa"
      width={size}
      height={size}
      className={className}
      style={filterStyle}
      aria-hidden="true"
    />
  );
};

// Mikassa Agency Logo component
export const MikassaLogo = ({ inverse = false, className = "", useImage = false }) => {
  const navy = "#0C2340";
  const orange = "#E8611A";
  const white = "#FAFAF8";
  const textColor = inverse ? white : navy;
  const subColor = orange;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="mikassa-logo">
      <MikassaMark size={44} tone={inverse ? "white" : "navy"} />
      <div className="leading-none">
        <div
          className="font-heading font-black tracking-tight text-[1.4rem]"
          style={{ color: textColor, letterSpacing: "0.02em" }}
        >
          Mikassa<span style={{ color: subColor }}>.</span>
        </div>
        {/* <div
          className="font-body text-[0.55rem] uppercase mt-1"
          style={{ color: textColor, letterSpacing: "0.32em", opacity: 0.75 }}
        >
          Admin
        </div> */}
        <div
          className="font-body text-[0.5rem] mt-0.5 uppercase"
          style={{ color: subColor, letterSpacing: "0.18em" }}
        >
          Gestion Locative
        </div>
      </div>
    </div>
  );
};

// Keep old exports for backwards compatibility during transition
export const DiamondNetworkMark = MikassaMark;
export const KidhLogo = MikassaLogo;
export const KIDH_LOGO_URL = "";

export default MikassaLogo;
